var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"21","height":"20","viewBox":"0 0 21 20","fill":"none"}},[_c('path',{attrs:{"d":"M8.1001 15L13.1001 10L8.1001 5","stroke":"#A4A7AE","stroke-width":"1.67","stroke-linecap":"round","stroke-linejoin":"round"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }